import React from "react";
import { Navigate, RouterProvider } from "react-router-dom";

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import NewPassword from "../pages/Authentication/NewPassword";

// Auth Inner
import LogoutBasic from "../pages/AuthenticationInner/LogoutBasic";
import SuccessMessage from "../pages/AuthenticationInner/SuccessMessage";
import AuthLockScreen from "../pages/AuthenticationInner/LockScreen";

// Error Pages
import OutOfPermission from "../pages/Authentication/Errors/OutOfPermission";

import RouteHandler from "../pages/RouteHandler";

// Settings 
import Settings from "../pages/Settings";
import PersonalDetails from "../pages/Settings/PersonalDetails";
import ChangePassword from "../pages/Settings/ChangePassword";
import CompanyDetails from "../pages/Settings/CompanyDetails";
import Client from "../pages/Settings/CompanyDetails/Client";
import Brand from "../pages/Settings/CompanyDetails/Brand";
import Market from "../pages/Settings/CompanyDetails/Market";
import UserList from "../pages/Settings/UserList";
import PrivacyPolicy from "../pages/Settings/PrivacyPolicy";

// Feeds
import Feeds from "../pages/Feeds";
import FeedLibrary from "../pages/Feeds/FeedLibrary";
import Feed from "../pages/Feeds/Feed";
import Fields from "../pages/Feeds/Feed/Fields";
import SortingAndFilters from "../pages/Feeds/Feed/SortingAndFilters";
import Usage from "../pages/Feeds/Feed/Usage";
import FeedSettings from "../pages/Feeds/Feed/FeedSettings";

// Campaigns
import Campaigns from "../pages/Campaigns";
import AllLibraries from "../pages/Campaigns/AllLibraries";
import Campaign from "../pages/Campaigns/Campaign";
// Studio
// import Fonts from '../pages/Fonts';
// Publish
import Publish from "../pages/Publish";
import WhereToPublish from "../pages/Publish/WhereToPublish";
// Analytics
import Analytics from '../pages/Analytics'
import Features from "../pages/LandingPages/Features";
import Home from "../pages/LandingPages/Home";
import Privacy from "../pages/LandingPages/Privacy";
import Terms from "../pages/LandingPages/Terms";
import BookDemo from "../pages/LandingPages/BookDemo";
import DemoConfirmation from "../pages/LandingPages/DemoConfirmation";
import Sigma from "../pages/LandingPages/Sigma";
import SigmaConfirmation from "../pages/LandingPages/SigmaConfirmation";
import UnderConstruction from "../pages/Authentication/UnderConstruction";
import FacebookAuthentication from "../pages/Publish/Social/Catalog/FacebookAuthentication";

const authProtectedPaths = [
	{ path: "", component: <Navigate to="campaigns/filter/all" /> },
	// Feeds
	{
		path: "feeds",
		component: <Feeds />,
		children: [
			{ path: "", component: <FeedLibrary /> },
			{ path: "folder", component: <FeedLibrary /> },
			{
				path: ":feed",
				component: <Feed />,
				children: [
					// { path: "", component: <Navigate to="fields" /> },
					{ path: "fields", component: <Fields /> },
					{ path: "sorting-filters", component: <SortingAndFilters /> },
					{ path: "usage", component: <Usage /> },
					{ path: "settings", component: <FeedSettings /> },
				]
			}
		]
	},
	// Campaigns
	{
		path: "campaigns",
		component: <Campaigns />,
		children: [
			{path: "", component: <Navigate to="filter/all" />},
			{
				path: "filter", component: <AllLibraries />, children: [
					{path: "", component: <Navigate to="all" />},
					{ path: "all", component: <AllLibraries /> },
					{ path: "display", component: <AllLibraries /> },
					{ path: "social", component: <AllLibraries /> },
					// { path: "video", component: <AllLibraries /> },
					// { path: "audio", component: <AllLibraries /> },
					// { path: "crm", component: <AllLibraries /> },
				]
			},
			{ path: ":campaignId", component: <Campaign /> }
		]
	},
	// {
	// 	path: 'fonts',
	// 	component: <Fonts />
	// },
	{
		path: 'publish',
		component: <Publish />,
		children: [
			{path: ':campaignId', component: <WhereToPublish />},
		]
	},
	{
		path: 'analytics',
		component: <Analytics />,
		children: [
			{path: '', component: <Analytics />},
			{path: ':campaignId', component: <Analytics />},
		]
	}
];

const authProtectedRoutes = [
	// Settings
	{
		path: "/settings",
		component: <Settings />,
		children: [
			{ path: "", component: <Navigate to="personal-details" /> },
			{ path: "personal-details", component: <PersonalDetails /> },
			{ path: "change-password", component: <ChangePassword /> },
			{
				path: "company-details",
				component: <CompanyDetails />,
				children: [
					{ path: "", component: <Client /> },
					{ path: ":client", component: <Brand /> },
					{ path: ":client/:brand", component: <Market /> },
				]
			},
			{ path: "user-list", component: <UserList /> },
			// { path: "privacy-policy", component: <PrivacyPolicy /> },
		]
	},
	// Facebook Authentication
	{
		path: '/facebook-authentication',
		component: <FacebookAuthentication />
	},
	{
		path: "/:client",
		component: <RouteHandler />,
		children: authProtectedPaths
	},
	{
		path: "/:client/:brand",
		component: <RouteHandler />,
		children: authProtectedPaths
	},
	{
		path: "/:client/:brand/:market",
		component: <RouteHandler />,
		children: authProtectedPaths 
	},
	// this route should be at the end of all other routes
	{
		path: "/",
		component: <RouteHandler />,
	},
	{ path: "*", component: <RouteHandler /> },
];

const publicRoutes = [
	// Landing Page
	{path: '/home', component: <Home />},
	{path: '/features', component: <Features />},
	{path: '/privacy', component: <Privacy />},
	{path: '/terms', component: <Terms />},
	{path: '/book-demo', component: <BookDemo />},
	{path: '/confirmation', component: <DemoConfirmation />},
	{path: '/sigma', component: <Sigma />},
	{path: '/sigmaConfirmation', component: <SigmaConfirmation />},
	// Authentication Page
	{ path: "/auth-logout", component: <Logout /> },
	{ path: "/login", component: <Login /> },
	{ path: "/forgot-password", component: <ForgetPasswordPage /> },
	{ path: "/new-password", component: <NewPassword /> },

	//Authentication Inner
	{ path: "/logout", component: <LogoutBasic /> },
	{ path: "/success", component: <SuccessMessage /> },
	// { path: "/lockscreen", component: <AuthLockScreen /> },

	// Error Pages
	{path: '/maintenance', component: <UnderConstruction />},
	{path: "/out-of-permission", component: <OutOfPermission />},
];

export { authProtectedRoutes, publicRoutes };